var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-wrap"},[_vm._l((_vm.badges),function(badge,index){return [_c('div',{key:index,staticClass:"tw-mr-2 tw-mb-2 tw-cursor-pointer",on:{"click":function($event){return _vm.showGoalBadgeDetails(badge)}}},[_c('UserPhoto',{staticClass:"tw-mb-1",attrs:{"photo":badge.url,"photo-size":[
        'tw-rounded-full',
        { 'tw-w-12 tw-h-12' : _vm.listSize === 'normal'},
        { 'tw-w-8 tw-h-8' : _vm.listSize === 'tiny'},
        { 'tw-w-24 tw-h-24' : _vm.listSize === 'large'},
      ],"title":badge.title}}),(_vm.listSize === 'large')?_c('p',{staticClass:"tw-font-bold tw-text-sm",staticStyle:{"max-width":"96px"}},[_vm._v(" "+_vm._s(badge.title)+" ")]):_vm._e()],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }